/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ApiHeader from '../../components/API/UIElements/Header';
import TitleBar from '../../components/API/UIElements/TitleBar';
import { useParams } from 'react-router-dom';
import Footer from '../../components/Footer';
import Overview from '../../components/API/Home/Overview';
import {
  ROUTES,
  notification,
  setElementHeights,
} from '../../assets/constants/strings';
import $ from 'jquery';
import './style.scoped.scss';
import Documentation from '../../components/API/Home/Documentation';
import LeftNav from '../../components/API/Home/LeftNav';
import { Content } from '../../components/API/Home/Content';
import { Policies } from '../../components/API/Home/Policies';
import clipboardCopy from 'clipboard-copy';
import { Redirect } from 'react-router-dom';
import Explorer from '../../components/API/Home/GraphExplorer/Explorer';
import Plans from '../../components/API/Home/Plans';
import { hasDeveloperApi, isAuthenticated } from '../../services/entitlements';

const mapStateToProps = (state) => ({
  user: state.user.user,
});

const connector = connect(mapStateToProps, null);

const ApiOverview = ({ user }) => {
  const { section } = useParams();
  const [docId, setDocId] = useState(0);

  const copyToClipboard = (text) => {
    clipboardCopy(text)
      .then(() => {
        console.log('Text copied to clipboard: ', text);
        notification('success', 'Copied to clipboard.');
      })
      .catch((error) => {
        console.error('Copy to clipboard failed: ', error);
      });
  };

  useEffect(() => {
    $(window).on('resize', setElementHeights);
  }, []);

  useEffect(() => {
    const updateDocId = () => {
      if (section) {
        if (section.includes('documentation')) {
          let id = section.split('-');
          if (id.length > 1) {
            setDocId(parseInt(id[1]));
          } else {
            setDocId(0);
          }
        }
      }
    };
    updateDocId();
  }, [section]);

  // useEffect(() => {
  //   const docs = getWebApiDocuments()
  //     console.log(docs);
  // }, []);

  const [currentPage, setCurrentPage] = useState('overview');
  const [pageTitle, setPageTitle] = useState('overview');
  const [selectedItem, setSelectedItem] = useState(
    currentPage.includes('documentation') ? Content()[2] : Policies[0]
  );

  useEffect(() => {
    if (section) {
      let i = 0;
      const split = section.split('-');
      if (split.length > 1) {
        i = parseInt(split[1]);
      }
      let updatedSection = section;
      if (section.includes('documentation')) {
        updatedSection = 'documentation';
      }
      setCurrentPage(updatedSection);
      setSelectedItem(
        updatedSection === 'documentation' ? Content()[i] : Policies[0]
      );
    } else {
      setCurrentPage('overview');
    }
    setElementHeights();
  }, [section]);

  // Tint the page's deepest background on the Overview route. The footer is
  // absolutely positioned at the bottom of the wrapper; on a short page a gap
  // opens between the tinted content and the footer, and whichever ancestor
  // shows through was white. Colouring <body> guarantees that gap is the canvas
  // tint — and because it's driven off currentPage it holds on SPA navigation,
  // not just a hard reload (which is where the earlier wrapper/min-height fixes
  // behaved inconsistently).
  useEffect(() => {
    document.body.classList.toggle(
      'api-canvas-overview',
      currentPage === 'overview'
    );
    return () => document.body.classList.remove('api-canvas-overview');
  }, [currentPage]);

  useEffect(() => {
    if (currentPage) {
      switch (currentPage) {
        case 'overview':
          return setPageTitle('RegulationCity API Platform');
        case 'documentation':
          return setPageTitle('Documentation');
        case 'explorer':
          return setPageTitle('API Explorer');
        case 'plans':
          return setPageTitle('Plans');
        case 'policies':
          return setPageTitle('Terms & Policies');

        default:
          break;
      }
    }
  }, [currentPage]);

  const pageMainContent = () => {
    switch (currentPage) {
      case 'overview': {
        return <Overview />;
      }
      case 'documentation': {
        return (
          <Documentation
            isDocumentation={true}
            selectedItem={selectedItem}
            handlecopy={copyToClipboard}
          />
        );
      }
      case 'policies': {
        return (
          <Documentation isDocumentation={false} selectedItem={selectedItem} />
        );
      }
      case 'explorer': {
        return <Explorer />;
      }
      case 'plans': {
        return <Plans />;
      }
      default:
        return null;
    }
  };

  const handleCLick = (item) => {
    setSelectedItem(item);
  };

  // Not authenticated (logged out, or the reducer's truthy "logged out" sentinel which has no
  // token) → the login page, NOT the activate page.
  if (!isAuthenticated(user)) {
    return <Redirect to={`${ROUTES.LOGIN}?portal=api`} />;
  }

  // No DeveloperApi entitlement → offer to add it to the existing account
  // (free tier) instead of bouncing back to the reader.
  if (user && !hasDeveloperApi(user)) {
    return <Redirect to={ROUTES.APIACTIVATE} />;
  }

  return (
    <div
      className={`wf-doc-wrapper w-100 ${
        currentPage === 'overview' ? 'api-wrapper--overview' : ''
      }`}
      id='wf-doc-page'
    >
      <nav id='sticky-top-wrapper' className='navbar sticky-top p-0'>
        <div className='w-100 d-flex flex-column '>
          <ApiHeader hasNav />
          {/* Overview renders its own light hero; other pages keep the slim banner. */}
          {currentPage !== 'overview' && (
            <TitleBar pageTitle={pageTitle} compact />
          )}
        </div>
      </nav>

      <main
        role='main'
        className={`wf-document px-0 mb-0 ${
          currentPage === 'overview' ? 'api-home--overview' : ''
        } ${
          currentPage === 'documentation' || currentPage === 'policies'
            ? 'api-home--docs'
            : ''
        }`}
        id='api-home'
      >
        {(currentPage === 'documentation' || currentPage === 'policies') && (
          <LeftNav
            isDocs={currentPage === 'documentation'}
            selectedItem={selectedItem}
            handleClick={handleCLick}
          />
        )}

        <div
          id='main-content'
          className={`col mr-4 ${
            currentPage === 'explorer' ? 'main-content--workbench' : ''
          }`}
        >
          {pageMainContent()}
        </div>
      </main>

      <Footer isDocument isCentered isAbsolute />
    </div>
  );
};

export default connector(ApiOverview);
